import { initReactI18next } from 'react-i18next';
import { CustomI18n, innerInitI18n } from './initI18n';

export function initI18n({
  resources,
  userLanguage,
  locize,
  useFormalLanguageOnLoad,
  missingKeyHandler,
}: Omit<Parameters<typeof innerInitI18n>[0], 'initReactI18next'>): CustomI18n {
  return innerInitI18n({
    resources,
    userLanguage,
    locize,
    useFormalLanguageOnLoad,
    missingKeyHandler,
    initReactI18next,
  });
}
